import { render, staticRenderFns } from "./zjtable.vue?vue&type=template&id=0d58e201&scoped=true"
import script from "./zjtable.vue?vue&type=script&lang=js"
export * from "./zjtable.vue?vue&type=script&lang=js"
import style0 from "./zjtable.vue?vue&type=style&index=0&id=0d58e201&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58e201",
  null
  
)

export default component.exports